import common from '@page/common/js/common';
import Index from '@page/shopContent/components/Index.vue';
import { createApp } from 'vue';

require('@global/vendors/jquery.sticky-kit');

const app = createApp({
  components: {
    Index,
  },
});
app.mount('#shop-content');
